import { ReactElement } from 'react';
import { CheckVerified, WarnCircle, XCircle } from 'icons';
import { colors } from 'styles/remoteControlColors';
import { HealthStatusContainer } from './styles';
import { HealthStatus } from 'pages/RemoteControl/MachineProfile/types';

type StatusVariant = 'green' | 'orange' | 'red';

interface HealthStatusIndicatorProps {
  status: HealthStatus;
}

interface StatusComponent {
  color: string;
  icon: ReactElement;
}

const infoByVariant: Record<StatusVariant, StatusComponent> = {
  green: {
    color: colors.Green500,
    icon: <CheckVerified />,
  },
  orange: {
    color: colors.Orange600,
    icon: <WarnCircle />,
  },
  red: {
    color: colors.Red600,
    icon: <XCircle size={16} color={colors.White} />,
  },
};

export const HealthStatusIndicator = ({
  status,
}: HealthStatusIndicatorProps): ReactElement => {
  function variantByStatus(): StatusVariant {
    switch (status) {
      case HealthStatus.NO_ALERT: return 'green';
      case HealthStatus.ALERT: return 'orange';
      case HealthStatus.INOPERATIVE: return 'red';
      default: throw Error('Health status not found');
    }
  }

  const statusInfo = infoByVariant[variantByStatus()];

  return (
    <HealthStatusContainer
      style={{ backgroundColor: statusInfo.color }}
      data-testid="health-status-indicator"
    >
      {statusInfo.icon}
    </HealthStatusContainer>
  );
};
